/**
 * 봇이 처리한 요청의 기능 — 대분류·소분류 10종. 키는 nd-ai-platform이 사용량 기록에 싣는 값
 * (`domain/classification/request-feature.ts`의 `REQUEST_FEATURES`)이고, 그쪽에서 값을 바꾸거나 더하면 여기도 고친다.
 *
 * 표의 순서가 화면 순서다. 표에 없는 새 키는 키 그대로 뒤에 붙는다.
 */
const FEATURES: ReadonlyArray<{ key: string; group: string; label: string }> = [
  { key: 'dev-request:submit', group: '개발요청', label: '신규 접수' },
  { key: 'dev-request:revise', group: '개발요청', label: '요청서 수정' },
  { key: 'dev-request:discuss', group: '개발요청', label: '논의' },
  { key: 'prd-draft:write', group: '사전 PRD', label: '초안 작성' },
  { key: 'prd-draft:revise', group: '사전 PRD', label: '초안 개정' },
  { key: 'answer:knowledge', group: '질문 답변', label: '지식베이스' },
  { key: 'answer:freeform', group: '질문 답변', label: '자유 답변' },
  { key: 'thread-summary', group: '스레드 요약', label: '' },
  { key: 'issue-report', group: '이슈 제보', label: '' },
  { key: 'data-query', group: '데이터 추출', label: '' },
];

export interface AiUsageFeatureRow {
  key: string;
  label: string;
  requests: number;
}

export class AiUsageFeature {
  /** `개발요청 · 신규 접수`. 소분류가 없는 대분류는 대분류 이름만. 모르는 키는 그대로. */
  static label(key: string): string {
    const feature = FEATURES.find((entry) => entry.key === key);
    if (!feature) return key;
    return feature.label === '' ? feature.group : `${feature.group} · ${feature.label}`;
  }

  /**
   * 차트에 그릴 줄 — 10종을 요청이 없어도 표 순서대로 모두 세우고(어느 기능이 안 쓰였는지도 보이게),
   * 표에 없는 키를 뒤에 붙인다.
   */
  static rows(counts: ReadonlyArray<{ feature: string; requests: number }>): AiUsageFeatureRow[] {
    const requestsOf = (key: string) => counts.find((count) => count.feature === key)?.requests ?? 0;
    const known = FEATURES.map((feature) => ({ key: feature.key, label: AiUsageFeature.label(feature.key), requests: requestsOf(feature.key) }));
    const unknown = counts
      .filter((count) => !FEATURES.some((feature) => feature.key === count.feature))
      .map((count) => ({ key: count.feature, label: count.feature, requests: count.requests }));
    return [...known, ...unknown];
  }
}
